import React from "react";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { ReactComponent as Crown } from "../../Assets/icons/subscription/crown.svg";
import { colors } from "../../Assets/styles/colors";
import LocalStorage from "../../Helpers/LocalStorage";
import moment from "moment/moment";
import { useTranslate } from '@tolgee/react';

const TryNowProCard = ({ setShowTryProCard, handleOpenSubscriptionModal, user }) => {
  const handleClose = () => {
    LocalStorage.setTryProCard(moment());
    setShowTryProCard(false);
  };

  const handleClick = () => {
    handleOpenSubscriptionModal();
  };
  const { t } = useTranslate();
  if (user?.accountType !== 'free') {
    return null;
  }
  return (
    <Container>
      <CloseBtn onClick={handleClose}>
        <CloseIcon />
      </CloseBtn>
      <Line onClick={handleClick}>
        <CrownWrapper>
          <Crown />
        </CrownWrapper>
        <Title>{t('pro_card.try_new')}</Title>
      </Line>
    </Container>
  );
};

export default TryNowProCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: ${({ theme }) => theme.menu.selectedOpionBackground};
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0px 0px 11.3px 0px
    ${({ theme }) => theme.menu.selectedOpionBackground};
  position: relative;
  margin: 5px 16px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const CrownWrapper = styled.div`
  border-radius: 100px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.menu.toggleFadedColor};
`;

const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;
const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: auto;
  max-width: 24px;
  position: absolute;
  top: -10px;
  right: -10px;
  svg {
    color: ${({ theme }) => theme.menu.selectedOpionBackground};
    stroke: ${({ theme }) => theme.sidebar.borderColor};
  }
`;

const Title = styled.h1`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
